/*
 *--------------------------------------------------------------------------
 * Listrak
 *--------------------------------------------------------------------------
 *
 * This class is used to implement elements of the Listrak JavaScript
 * integration.
 *
 * https://help.listrak.com/en/articles/2459629-javascript-integration-guide
 *
 */

import EventBus from '@mvps-genesis/event-bus';
import {ParameterValidator, decodeEntities} from '@mvps-genesis/utilities';

export default class Listrak {

	/**
	 * Cart data attribute name
	 *
	 * @var	String
	 */
	cartAttributeName;

	/**
	 * The mini-basket container selector
	 *
	 * @var String
	 */
	containerSelector;

	/**
	 * Class options object
	 *
	 * @var Object
	 */
	options;

	/**
	 * Parameter Validator object
	 *
	 * @var	@mvps-genesis/utilities	ParameterValidator
	 */
	#validator;

	/**
	 * Create a new Listrak object
	 *
	 * @param	String	options.cartAttributeName	The cart data attribute name. Defaults to 'data-listrak-cart'.
	 * @param	String	options.containerSelector	The mini-basket container selector. Defaults to '.js-mini-basket'.
	 */
	constructor (options = {}) {
		// Create param validator
		this.#validator = new ParameterValidator(this);

		// Store the provided options
		this.options = this.#validator.isObject('options', options);

		this.cartAttributeName = this.#validator.isString('options.cartAttributeName', this.options.cartAttributeName || 'data-listrak-cart');
		this.containerSelector = this.#validator.isString('options.containerSelector', this.options.containerSelector || '.js-mini-basket');

		this.bindEvents();
	}

	bindEvents () {
		this.onAddToCart();
	}

	onAddToCart () {
		// Listrak Integration: Cart Activity
		EventBus.addEventListener('MVPS:addToCart', (event) => {
			if (event.detail && event.detail.success === true && typeof event.detail.data === 'object') {

				const miniBasket = event.detail.data.querySelector(this.containerSelector);

				if (!miniBasket) {
					return false;
				}

				const cartAttributeElement = miniBasket.querySelector(`[${this.cartAttributeName}]`);

				if (!cartAttributeElement) {
					return false;
				}

				const cartData = JSON.parse(decodeEntities(cartAttributeElement.getAttribute(this.cartAttributeName)));

				if (!cartData || !cartData.length) {
					return false;
				}

				/* eslint-disable block-spacing, curly, eqeqeq, func-style, keyword-spacing, max-statements-per-line, new-cap, no-undef, no-use-before-define, no-shadow, semi, space-before-blocks, space-before-function-paren, wrap-iife */
				(function(){if(typeof _ltk == 'object'){ltkCode();}else{(function (d) { if (document.addEventListener) document.addEventListener('ltkAsyncListener', d); else { e = document.documentElement; e.ltkAsyncProperty = 0; e.attachEvent('onpropertychange', function (e) { if (e.propertyName == 'ltkAsyncProperty') { d(); } }); } })(function(){ltkCode();});}function ltkCode(){_ltk_util.ready(function(){
					cartData.forEach(item => {
						_ltk.SCA.AddItemWithLinks(String(item.sku).replace(',', ''), parseInt(item.quantity, 10), item.price, item.product_title, item.image_url, item.product_url);
					});
					_ltk.SCA.Submit();
				})}})();
				/* eslint-enable block-spacing, curly, eqeqeq, func-style, keyword-spacing, max-statements-per-line, new-cap, no-undef, no-use-before-define, no-shadow, semi, space-before-blocks, space-before-function-paren, wrap-iife */
			}

			return true;
		});
	}
}
